import { PropsWithChildren } from "react";

interface PaginationHeaderProps {
  title: string;
  button?: {
    label: string;
    href: string;
  };
}

const PaginationHeader = ({
  title,
  button,
  children
}: PropsWithChildren<PaginationHeaderProps>) => (
  <header className="px-6 pt-9" style={{ backgroundColor: "#f9fafb" }}>
    <div className="flex justify-between items-center">
      <h1 className="text-2xl font-bold text-ctb-blue" style={{ fontFamily: 'Montserrat, sans-serif' }}>{title}</h1>
      {button && (
        <a
          href={button.href}
          className="text-white px-4 py-2 rounded-md font-medium"
          style={{ backgroundColor: '#010D2C' }}
        >
          {button.label}
        </a>
      )}
    </div>
    {children}
  </header>
);

export default PaginationHeader;